import React from 'react';
import styles from './QMonthApproval.module.scss';
import HATVABOTable from '../HATVABOTable/HATVABOTable';
import MyAccountsLoader from '../../../common/Loaders/MyAccountsLoader/MyAccountsLoader';
import { useTranslation } from 'react-i18next';

interface QMonthApprovalProps {
  data: TableRowData[] | undefined;
  isLoading: boolean;
  isError: boolean;
  setIsStatusUpdate?: (apiStatus: string) => void;
}
const QMonthApproval: React.FC<QMonthApprovalProps> = ({
  data,
  isLoading,
  isError,
  setIsStatusUpdate,
}) => {
  const { t } = useTranslation();

  if (isLoading || data === undefined) {
    return <MyAccountsLoader num={6} hideCustomViewPanel />;
  }
  if (!isError && data.length > 0) {
    return (
      <div data-testid="hatv_qMonth_testID">
        <HATVABOTable data={data} setIsStatusUpdate={setIsStatusUpdate} type={'hatvqmonth'} />
      </div>
    );
  }

  if (!isLoading && !isError && data.length === 0) {
    return (
      <div className={styles.empty_state_document}>
        <div className={`table_no_data ${styles.empty_state_msg}`}>{t('noAboAvailable')}</div>
      </div>
    );
  }

  return null;
};

export default QMonthApproval;
